var exports = {
  "EF": "pageHeading__92CITK",
  "Ci": "activityList__clTHmv",
  "M0": "feedbackLink__1NTOzO",
  "GW": "feedbackTextFull__v52r79",
  "fT": "feedbackTextShort__ed7P1n",
};

module.exports = exports;
